import request from "@utils/request";

const list = async (args?: any) => {
  return await request({
    url: "deals",
    method: "get",
    authorization: true,
  });
};

const find = async (args: any) => {
  return await request({
    url: `deals/${args.id}`,
    method: "get",
    authorization: true,
  });
};

const create = async (args: any) => {
  return await request({
    url: "deals",
    method: "post",
    data: args.data,
    authorization: true,
  });
};

const update = async (args: any) => {
  return await request({
    url: `deals/${args.id}`,
    method: "patch",
    data: args.data,
    authorization: true,
  });
};

const remove = async (args: any) => {
  return await request({
    url: `deals/${args.id}`,
    method: "delete",
    authorization: true,
  });
};

const addProducts = async (payload: any) => {
  const formData = new FormData();
  if (payload.dealId) formData.append("dealId", payload.dealId);

  if (payload.items && Array.isArray(payload.items)) {
    payload.items.forEach((item: any, index: number) => {
      formData.append(`items[${index}][storeId]`, item.storeId);
      if (item.title) formData.append(`items[${index}][title]`, item.title);

      if (item.image) {
        // Handle various image formats from Upload component
        if (item.image instanceof File) {
          formData.append(`items[${index}][image]`, item.image);
        } else if (item.image.rawFile) {
          formData.append(`items[${index}][image]`, item.image.rawFile);
        } else if (Array.isArray(item.image) && item.image[0]?.rawFile) {
          formData.append(`items[${index}][image]`, item.image[0].rawFile);
        }
      }

      // Send products as JSON string
      formData.append(
        `items[${index}][products]`,
        JSON.stringify(item.products),
      );
    });
  }

  return await request({
    url: "deals/add-items",
    method: "post",
    data: formData,
    authorization: true,
  });
};

const listStoreDeals = async (args?: any) => {
  return await request({
    url: "store/deals",
    method: "get",
    authorization: true,
  });
};

export default {
  list,
  listStoreDeals,
  find,
  create,
  update,
  remove,
  addProducts,
};
